import { useState } from 'react';
import { toast } from '../use-toast';
import { showErrorToast } from '../../utils/errorHandler';

/**
 * Custom hook to manage OTP verification for deliveries
 */
export const useOTPVerification = (ride, onVerificationSuccess) => {
  const [showOTPDialog, setShowOTPDialog] = useState(false);
  const [otpType, setOtpType] = useState(''); // 'pickup' or 'delivery'
  const [otpCode, setOtpCode] = useState('');
  const [verifyingOTP, setVerifyingOTP] = useState(false);

  const promptForOTP = (type) => {
    setOtpType(type);
    setShowOTPDialog(true);
    
    const message = type === 'pickup'
      ? 'Get pickup OTP from sender to start delivery'
      : 'Get delivery OTP from receiver to complete delivery';
    
    toast({
      title: 'OTP Required',
      description: message,
    });
  };

  const verifyOTP = async () => {
    setVerifyingOTP(true);
    
    try {
      const api = (await import('../../utils/api')).default;
      await api.post('/deliveries/verify-otp', {
        delivery_id: ride.id,
        otp_code: otpCode,
        otp_type: otpType
      });

      toast({
        title: 'OTP Verified',
        description: `${otpType === 'pickup' ? 'Pickup' : 'Delivery'} OTP verified successfully`,
      });

      setShowOTPDialog(false);
      setOtpCode('');
      
      // Call success callback if provided
      if (onVerificationSuccess) {
        await onVerificationSuccess(otpType);
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      showErrorToast(toast, error, 'OTP verification failed');
    } finally {
      setVerifyingOTP(false);
    }
  };

  const closeOTPDialog = () => {
    setShowOTPDialog(false);
    setOtpCode('');
  };

  return {
    showOTPDialog,
    otpType,
    otpCode,
    setOtpCode,
    verifyingOTP,
    promptForOTP,
    verifyOTP,
    closeOTPDialog,
  };
};
